import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ['hourDisplay', 'minuteDisplay', 'input', 'hourControl', 'minutesControl']

  /* == Actions == */
  display (e) {
    this.hourDisplayTarget.textContent = this.hourControlTarget.value
    this.minuteDisplayTarget.textContent = this.minutesControlTarget.value
  }

  focus (e) {
    e.currentTarget.dataset.savedValue = e.currentTarget.value
    e.currentTarget.value = ''
  }

  blur (e) {
    const target = e.currentTarget
    if (target.value === '') target.value = target.dataset.savedValue
  }

  hourChanged (e) {
    const value = e.target.value

    if (Number(value) > 23) {
      e.target.value = null
      return
    }

    this.updateTime()
    if (value.length === 2) this.minutesControlTarget.focus()
  }

  minutesChanged (e) {
    const value = e.target.value

    if (Number(value) > 59) {
      e.target.value = null
      return
    }

    this.updateTime()
    if (value.length === 2) this.minutesControlTarget.blur()
  }

  /* == Logic == */
  updateTime () {
    this.inputTarget.value = `${this.hour}:${this.minutes}`
  }

  /* == Getters & Setters == */
  get hour () {
    return this.hourControlTarget.value.padStart(2, '0')
  }

  get minutes () {
    return this.minutesControlTarget.value.padStart(2, '0')
  }
}
